import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  ImageSizeFieldSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

export enum LogoSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
}

const LogoBarHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const LogoBarLogoFieldSchema = ImageFieldSchema.extend({
  name: z.literal('logo'),
  role: z.literal(FieldRole.Logo),
});

const LogoBarLogoSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('size'),
  role: z.literal(FieldRole.Logo),
});

const LogoBarFieldGroupFieldSchema = z.discriminatedUnion('name', [LogoBarLogoFieldSchema, LogoBarLogoSizeFieldSchema]);

const LogoBarHeaderFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(LogoBarHeaderFieldSchema),
});

const LogoBarLogoFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(LogoBarFieldGroupFieldSchema),
});

const LogoSizeSchema = z.nativeEnum(LogoSize);

const LogoBarOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  headerEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
  logoSize: LogoSizeSchema.optional(),
  layout: z.string().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
});

export const LogoBlockConfigSchema = z.object({
  options: LogoBarOptionsSchema,
  type: z.literal(BlockType.LogoBar),
  fieldGroups: z.tuple([LogoBarHeaderFieldGroupSchema]).rest(LogoBarLogoFieldGroupSchema),
  version: z.literal(1),
});
